<template>
  <div id="primary-nav" class="lg:flex lg:items-stretch">
    <div :class="{ 'header-nav--active': showMenu == true }"  class="header-nav z-50">
      <ul class="flex items-center">
        <li class="">
          <router-link to="/products" @click.native="closeMenu()">
            <font-awesome-icon icon="list-ul" class="mr-2 hover:mr-4" />
            Browse all products
          </router-link>
        </li>
        <li class="" >
          <router-link to="/page/help" @click.native="closeMenu()">
            <font-awesome-icon :icon="['far', 'question-circle']" class="mr-2 hover:mr-4" />
            Help
          </router-link>
        </li>
        <li class="">
          <router-link to="/page/ihm" @click.native="closeMenu()">
            <font-awesome-icon :icon="['fas', 'check']" class="mr-2 hover:mr-4" />
            IHM Service
          </router-link>
        </li>
      </ul>
      <div class="header-nav__account">
        <a href="/control/" target="_blank" class="mr-8"  v-if="$store.state.user.isAdmin">
          Admin
          <font-awesome-icon :icon="['far', 'cog']" class="ml-2 hover:ml-4" />
        </a>
        <a href="/logout/">
          Log-out
          <font-awesome-icon :icon="['fas', 'sign-out']" class="ml-2 hover:ml-4" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    showMenu: Boolean
  },
  methods: {
    closeMenu: function () {
      this.$store.commit('menu/closeMenu')
    }
  },
}
</script>

<style>
  @media screen and (max-width: 1279px) {
    .header-nav {
      @apply hidden absolute w-full h-screen p-4 bg-white inset-0 mt-16;
    }
    .header-nav--active {
      @apply block;
    }
    .header-nav ul {
      @apply flex-col items-start;
    }
    .header-nav li {
      @apply font-bold mb-4 text-2xl;
    }
    .header-nav__account {
      @apply py-4;
    }
  }
  @media screen and (min-width: 1280px) {
    .header-nav {
      @apply flex flex-grow justify-between items-stretch  text-base font-medium ;
    }
    .header-nav li {
      @apply ml-10;
    }
    .header-nav__account {
      @apply px-6 flex items-center;
    }
  }
</style>